import {
  getBrand,
  getBrandName,
  ReservationHandler,
  isWRCCHolder,
  getSessionStorage,
  setLocalStorage
} from '../base/session-handler.js';
import CancelReservation from '../components/cancel-reservation.js';
import {
  exists,
  isMobileWidth
} from '../base/dom-utils.js';
import RateDetails from '../components/rate-details.js';
import {
  _isNotNull,
  getDateFromDateString,
  getLocaleUrlToken,
  isSMORate,
  CookieHandler,
  isGoFreeRate,
  checkSessionForDualBrandImage,
  clientDOMOpenRedirectSafe,
  EventHandler
} from '../base/utils.js';
import {
  isFluentEnabled,
  getFluentEnabledCountries,
  getFluentPlacementId
} from '../base/fluent-config.js';
import {
  $_PAGE_,
  overview_propertyId,
  overview_propertyName,
  property_address,
  property_city_name,
  property_country_code,
  property_postal_code,
  property_state_code,
  roomrate_redirect_url,
  confirmation_referrer,
  additionalCorpCodes,
  SESSION_PROFILE,
  CID_COOKIE
} from '../base/vars.js';
import Analytics from '../base/wyn-analytics-module.js';
import BnplAnalytics from '../base/bnpl-uplift-analytics.js';

// Hash type enum for PII normalization
const HashType = {
  EMAIL: 'email',
  PHONE: 'phone'
};

class ConfirmationPage {
  constructor() {
    if ($_PAGE_.hasClass('confirmation-page')) {
      checkSessionForDualBrandImage();
    }
    if ($_PAGE_.is('.confirmation-page') && !($_PAGE_.is('.authoring'))) {
      this.reservation = ReservationHandler.getReviewReservation();
      if (additionalCorpCodes && this.reservation.corporateCode && (additionalCorpCodes.indexOf(this.reservation.corporateCode) > -1)) {
        $('.confirmation-component').addClass('hold-rate');
        $('.confirmation-title').find('.headline-e:not(.title-hold-rate)').hide();
        $('.res-sum-modify-cancel .modify-button').hide();
      }

      if (($_PAGE_.hasClass('confirmation-page') && ($('.page-content').hasClass('reservation-found') || $('.page-content').hasClass('reservation-canceled'))) && (this.reservation.rateCode && isSMORate(this.reservation.rateCode))) {
        $('.confirmation-component').addClass('hold-rate');
        $('.res-sum-modify-cancel .modify-button').hide();
      }
      this.populateRateInformation();

      CancelReservation.enableCancel();

      this.handleContentModule();
      this.bindLinks();
      this.handleAnalytics();
      this.catchBackButtonClicks();
      this.handleCaesarsRewards();
      //"confirmationView" Event Activation Point - Push Adobe Digital Data After Successful Reservation.
      if (window.location.href.indexOf('reservation/confirm') > -1) {
        const interval = setInterval(() => {
          if (window.adobeDataLayer && window.adobeDataLayer.some(item => item.event === 'pageView')) {
            clearInterval(interval);
            window.AdobeWebSdk && window.AdobeWebSdk.afterReservationSuccessInConfirmationPage();
          }
        }, 100);
      }

      // FLUENT AD TECH INTEGRATION
      // Wait for profile status to be determined before initializing
      // EventHandler.profile.fetched fires for ALL users (logged in, logged out, or session restored)
      if (typeof EventHandler !== 'undefined' && EventHandler.profile && EventHandler.profile.fetched) {
        EventHandler.one(EventHandler.profile.fetched, () => {
          this.initFluentModal();
        });
      } else {
        // Fallback if EventHandler not available
        this.initFluentModal();
      }

      // AFFINION BANNER - Show after Fluent modal is dismissed (better UX - one modal at a time)
      this.initAffinionAfterFluent();

      //WRCCBarclay changes
      if(CookieHandler.cidAuthenticated() && isWRCCHolder() && isGoFreeRate(this.reservation.rateCode)){
          this.$0 = $('.page-content,footer');
          this.$ratePlanRibbon = this.$0.find('.discount-ribbon');
          this.$totalpoints = this.$0.find('.points-total .val');
			if (this.$ratePlanRibbon.length) {
			this.$ratePlanRibbon.removeClass('hidden');
			}
			if (this.$totalpoints.length && this.reservation.totalPoints) {
				this.$totalpoints.html('<strike>' + this.reservation.totalPoints + '</strike>');
			}
      }
    }
}

  populateRateInformation() {
    $('.title-reserved span,.title-cancelled span').addClass('aem-token customer-first-name');

    if (this.reservation.taxList.match(/[\[{].*[}\]]/)) {
      RateDetails.fillTaxes(JSON.parse(this.reservation.taxList), this.reservation.currencyCode, '', getBrand(true),this.reservation,'summary');
    } else {
      RateDetails.fillTaxes('', this.reservation.currencyCode, this.reservation.taxList, getBrand(true),this.reservation,'summary');
    }

    if ((this.reservation.dateRateMap.toString().length > 0) && _isNotNull(this.reservation.dateRateMap)) {
      let dateRateMap = JSON.parse(this.reservation.dateRateMap);
      if (typeof dateRateMap === 'object' && !($.isEmptyObject(dateRateMap))) {
        RateDetails.updateRateBreakdown(dateRateMap, this.reservation.currencyCode);
      } else {
        $('.rate-breakdown').hide();
      }
    } else {
      $('.rate-breakdown').hide();
    }
  }

  handleContentModule() {
    if (exists($('.content-module-component'))) {
      let aemRefBrand = this.reservation.referringBrand,
        contentModule = $('.content-module-component');
      $(contentModule).each((i, el) => {
        let contentModuleBrand = $(el).data('brand-codes');
        if (_isNotNull(contentModuleBrand)) {
          (contentModuleBrand.match(aemRefBrand)) ? $(el).show() : $(el).hide();
        } else {
          $(el).show();
        }
      });
    }
  }

  bindLinks() {
    $('.search-new-hotel').click(() => {
      window.location.replace(window.location.pathname.replace(/\/reservation.*/, ''));
    });

    if (roomrate_redirect_url && overview_propertyId) {
      $('.book-another-link').click((e) => {
        if(CookieHandler.sessionExists()){
          const currencies = getSessionStorage(CID_COOKIE,'currencies');
          let cookieSession = CookieHandler.getSession();
          const currencyObj = currencies ? currencies.find(item => item.typeCode === 'POINTS') : null;
          const points  = currencyObj && currencyObj.available ? currencyObj.available : 0;
          const sessionInfo = {
            ...cookieSession,
            points: points
          };
          setLocalStorage(SESSION_PROFILE, sessionInfo, true);
        }
        const link = roomrate_redirect_url + '?hotel_id=' + overview_propertyId;
        if(e.currentTarget.parentElement.parentElement.classList.contains('cancelled')) {
          window.AdobeWebSdk && window.AdobeWebSdk.onPostCancellationRebookReservationCancelConfirmPage(e.currentTarget, link);
        }
        location.href = roomrate_redirect_url + '?hotel_id=' + overview_propertyId;
      });
    } else {
      $('.book-another-link').remove();
    }

    $('.modify-button a').click((e) => {
      let data = {
        ...this.reservation,
        packages: typeof this.reservation.packages === 'string' 
          ? this.reservation.packages 
          : JSON.stringify(this.reservation.packages || {}),
        customerPhoneNum: this.reservation.customerPhone,
      };
      delete data['customerPhone'];
      e.preventDefault();
      let localeFixed = getLocaleUrlToken(); //DAI-462 : EN-CA Validations
      $('#modifyFormForAEMPost').attr('action', localeFixed + '/' + getBrandName() + '/reservation/modify');
      //"modifyreservationconfirmClick" Event Activation Point - Push Adobe Digital Data On Click of Modify link in Confirmation Page.
      window.AdobeWebSdk && window.AdobeWebSdk.onModifyBtnClickInConfirmationPage(e.currentTarget);
      ReservationHandler.postReservationDataToAEM(data, $('#modifyFormForAEMPost'), 'confirmation');
    });

    $('.export-to-cal').click((e) => {
      e.preventDefault();
      this.createCalendarEvent();
    });

    $('.print-reservation').click((e) => {
      e.preventDefault();
      window.print();
    });

    // load uplift disclaimer phone number click event
    BnplAnalytics.trackUpliftDisclaimerPhoneClick();

  }

  createCalendarEvent() {
    function _ensureTwo(value) {
      return (value < 10 ? '0' : '') + value;
    }

    function formatcalDateTime(dateTime, local) {
      return (!dateTime ? '' : (local ?
        '' + dateTime.getFullYear() + _ensureTwo(dateTime.getMonth() + 1) +
        _ensureTwo(dateTime.getDate()) + 'T' + _ensureTwo(dateTime.getHours()) +
        _ensureTwo(dateTime.getMinutes()) + _ensureTwo(dateTime.getSeconds()) :
        '' + dateTime.getUTCFullYear() + _ensureTwo(dateTime.getUTCMonth() + 1) +
        _ensureTwo(dateTime.getUTCDate()) + 'T' + _ensureTwo(dateTime.getUTCHours()) +
        _ensureTwo(dateTime.getUTCMinutes()) + _ensureTwo(dateTime.getUTCSeconds()) + 'Z'));
    }

    function getCalString(event) {
      var limit75 = function(text) {
        var out = '';
        while (text.length > 75) {
          out += text.substr(0, 75) + '\n';
          text = ' ' + text.substr(75);
        }
        out += text;
        return out;
      };
      return 'BEGIN:VCALENDAR\n' +
        'VERSION:2.0\n' +
        'PRODID:jquery.icalendar\n' +
        'METHOD:PUBLISH\n' +
        'BEGIN:VEVENT\n' +
        'UID:' + new Date().getTime() + '@' +
        (window.location.href.replace(/^[^\/]*\/\/([^\/]*)\/.*$/, '$1') || 'localhost') + '\n' +
        'DTSTAMP:' + formatcalDateTime(new Date()) + '\n' +
        (event.url ? limit75('URL:' + event.url) + '\n' : '') +
        (event.contact ? limit75('MAILTO:' + event.contact) + '\n' : '') +
        limit75('TITLE:' + event.title) + '\n' +
        'DTSTART:' + formatcalDateTime(event.start) + '\n' +
        'DTEND:' + formatcalDateTime(event.end) + '\n' +
        (event.summary ? limit75('SUMMARY:' + event.summary) + '\n' : '') +
        (event.description ? limit75('DESCRIPTION:' + event.description) + '\n' : '') +
        (event.location ? limit75('LOCATION:' + event.location) + '\n' : '') +
        (event.recurrence ? event.recurrence + '\n' : '') +
        'END:VEVENT\n' +
        'END:VCALENDAR';
    }

    let calevent = {},
      fdate = getDateFromDateString(this.reservation.checkInDate),
      tdate = getDateFromDateString(this.reservation.checkOutDate);

    calevent.title = 'Reservation';

    calevent.location = property_address + ', ' + property_city_name + ', ' + property_state_code + ', ' + property_country_code + ', ' + property_postal_code;
    let overview_propertyNameForCalendar = overview_propertyName.replace(/&amp;+/gi,'and').replace(/&#39;+|&#34;+/gi,'');
    calevent.description = 'Your stay at ' + overview_propertyNameForCalendar;

    calevent.start = new Date(fdate.getFullYear(), fdate.getMonth(), fdate.getDate(), 0, 0, 0);
    calevent.end = new Date(tdate.getFullYear(), tdate.getMonth(), tdate.getDate(), 0, 0, 0);

    calevent.summary = 'Hotel Reservation @ ' + overview_propertyNameForCalendar;

    let loc = '/BWSServices/services/booking/calendar?content=' + encodeURIComponent(getCalString(calevent));
    window.location.href = clientDOMOpenRedirectSafe(loc);

    $('.export-to-cal').attr('disabled','disabled');
  }

  handleAnalytics() {
    Analytics.setConfirmationAnalyticsData(this.reservation);
    Analytics.fireAnalyticsPageEvent();
  }

  catchBackButtonClicks() {
    // Back button code for confirmation page
    if (!(document.referrer.match(/wyndham\-rewards/))) {
      window.onload = () => {
        // Push 2 states to stack. One for current page, one for if user clicks back button
        history.pushState('catch-back', null, null);
        history.pushState('currentstate', null, null);
        window.addEventListener('popstate', (e) => {
          // If user goes back, state will become 'catch-back'.
          // If user refreshes or logs out, state will be null.
          if (e.state === 'catch-back') {
            // Currentstate has been removed from history by back click. Push replacement to stack and alert user of error.
            history.pushState('newcurrentstate', null, null);
            alert($('.confirmation-component').attr('data-back-button-prevention-text'));
          }
        });
      };
    }
  }
  /**
   * Initialize Affinion banner to show after Fluent modal is dismissed
   * Ensures only one modal is shown at a time
   */
  initAffinionAfterFluent() {
    let affinionShown = false;

    // Wait for Fluent modal to be dismissed
    window.addEventListener('flowContainerClosed', () => {
      if (!affinionShown) {
        affinionShown = true;
        setTimeout(() => {
          this.handleAffinionBanner();
        }, 500);
      }
    }, { once: true });

    // Fallback: If Fluent doesn't show after 3 seconds, show Affinion
    setTimeout(() => {
      if (!affinionShown) {
        const fluentModal = $('.fluent-af-exp-modal');
        if (!fluentModal.length || !fluentModal.hasClass('fluent-af-exp-modal--open')) {
          affinionShown = true;
          this.handleAffinionBanner();
        }
      }
    }, 3000);
  }

  handleAffinionBanner() {
    if (exists($('.affinion-banner')) && !isMobileWidth()) {
      $('#affinionBanner').modal({
        show: true,
        remote: false
      });
    }
  }

  handleCaesarsRewards() {
    const notification = $('#caesars-notify');
    const caesarsEnrollFlag = sessionStorage.getItem('caesarsEnrollFlag') || false;
    if(caesarsEnrollFlag) {
      console.info('Showing Caesars Message');
      notification.css('display','block');
    }
    // Clear the flag in case we book again
    sessionStorage.removeItem('caesarsEnrollFlag');
  }

  // ==================== FLUENT AD TECH INTEGRATION ====================

  /**
   * Wait for Fluent SDK to load and expose FlowContainer
   * @returns {Promise} - Resolves when FlowContainer is available, rejects after timeout
   */
  waitForFluentSDK() {
    return new Promise((resolve, reject) => {
      // Check if already loaded
      if (window.FlowContainer && typeof window.FlowContainer === 'function') {
        resolve();
        return;
      }

      // Poll for FlowContainer with timeout
      let checkCount = 0;
      const maxChecks = 100; // 10 seconds (100 * 100ms)

      const interval = setInterval(() => {
        checkCount++;

        if (window.FlowContainer && typeof window.FlowContainer === 'function') {
          clearInterval(interval);
          resolve();
        } else if (checkCount >= maxChecks) {
          clearInterval(interval);
          reject(new Error('FlowContainer not available after 10 seconds'));
        }
      }, 100);
    });
  }

  /**
   * Wait for user profile with preferences to be fetched
   * Fast path: Returns immediately if preferences already loaded (normal flow from booking page)
   * Slow path: Waits for EventHandler if profile still loading (direct navigation edge case)
   * @returns {Promise<Object|null>} - Resolves with loggedUser object if logged in, null if not logged in
   */
  waitForProfileFetch() {
    return new Promise((resolve) => {
      const userHandler = window.Wyndham && window.Wyndham.UserHandler;

      // Not logged in → resolve with null
      if (!userHandler || typeof userHandler.isWRLoggedIn !== 'function' || !userHandler.isWRLoggedIn()) {
        resolve(null);
        return;
      }

      // FAST PATH: Check if preferences are already loaded (99% of cases)
      if (typeof userHandler.getWRObject === 'function') {
        const loggedUser = userHandler.getWRObject();
        if (loggedUser && loggedUser.preferences && Array.isArray(loggedUser.preferences)) {
          resolve(loggedUser);
          return;
        }
      }

      // SLOW PATH: Preferences not ready yet (edge case: direct navigation, API in flight)
      if (typeof EventHandler !== 'undefined' && EventHandler.fullProfile) {
        EventHandler.one(EventHandler.fullProfile.fetched, () => {
          const wrObject = userHandler.getWRObject ? userHandler.getWRObject() : null;
          resolve(wrObject);
        });

        // Timeout after 5 seconds if profile doesn't load
        setTimeout(() => {
          resolve(null);
        }, 5000);
      } else {
        resolve(null);
      }
    });
  }

  /**
   * Initialize Fluent modal with country and session checks
   */
  async initFluentModal() {
    // ONLY show Fluent on NEW bookings, NOT on Find/Modify flows
    // confirmation_referrer is set in content.jsp from confirmationBean.referrer
    if (confirmation_referrer !== 'book') {
      return;
    }

    // Prevent double initialization
    if (this.fluentInitialized) {
      return;
    }
    this.fluentInitialized = true;

    try {
      // Check if Fluent is enabled in config
      const fluentEnabled = isFluentEnabled();

      if (!fluentEnabled) {
        return;
      }

      // Wait for profile preferences (logged-in users only)
      // Returns loggedUser object if logged in, null if not logged in
      const loggedUser = await this.waitForProfileFetch();

      // Show Fluent ads to ALL users (regardless of marketing opt-out preference)
      // Users who opted out of data sharing will see ads WITHOUT personalization (PII excluded)
      // This is handled in loadFluentModal() via checkMarketingOptOut()

      // Determine user country: authenticated users use profile, guests use booking country
      this.profileCountry = (loggedUser && loggedUser.country) || '';

      const billingCountry = this.reservation.customerCountry || '';

      this.userCountry = this.profileCountry || billingCountry;

      const enabledCountries = getFluentEnabledCountries();

      // Normalize country codes to uppercase for case-insensitive comparison
      // All country codes in the system are already 2-letter ISO format (US, CA)
      const normalizedUserCountry = this.userCountry.toUpperCase();
      const isEligibleCountry = enabledCountries.some(c =>
        normalizedUserCountry === c.toUpperCase()
      );

      if (!isEligibleCountry) {
        return;
      }


      // NOTE: PII is excluded for:
      // 1. Guest users (not authenticated)
      // 2. Authenticated users who opted out of data sharing
      // In both cases, we still show the modal but without personalization

      // Wait for Fluent SDK to be ready
      await this.waitForFluentSDK();
      this.loadFluentModal(loggedUser);

    } catch (error) {
      console.error('Error in initFluentModal:', error);
    }
  }

  /**
   * Load and configure Fluent modal with customer data (per PDF specification)
   * @param {Object|null} loggedUser - User profile object (null if not logged in)
   */
  async loadFluentModal(loggedUser) {
    try {
      // Check if user is authenticated
      const isAuthenticated = !!loggedUser;

      // Check if user has opted out of marketing
      const hasMarketingOptOut = this.checkMarketingOptOut(loggedUser);

      // Build params object per PDF specification
      const params = {};

      // Exclude PII if user is NOT authenticated OR has opted out of data sharing
      const shouldExcludePII = !isAuthenticated || hasMarketingOptOut;

      // ========== COMMON FIELDS (always sent) ==========
      // Transaction and location data (non-PII)
      params.transactionvalue = this.formatTransactionValue(this.reservation.totalCash);
      // confirmationNumbers is a comma-separated string, split and get first one
      let orderid = '';
      if (this.reservation.confirmationNumbers) {
        const confirmNumArray = typeof this.reservation.confirmationNumbers === 'string' 
          ? this.reservation.confirmationNumbers.split(',')
          : this.reservation.confirmationNumbers;
        orderid = confirmNumArray[0] || '';
      }
      params.orderid = orderid || '';
      params.state = this.reservation.customerState || '';
      params.zip = this.reservation.customerZip || '';
      params.country = this.userCountry || '';

      // Property info (Wyndham-specific, non-PII)
      params.reservationpropertyname = overview_propertyName || '';
      params.reservationpropertyzip = property_postal_code || '';
      params.reservationpropertystate = property_state_code || '';

      // ========== PII-SPECIFIC FIELDS ==========
      if (shouldExcludePII) {
        // Guest user OR opted-out user: STILL SHOW ADS but EXCLUDE PII
        params.opt_out = 'true';

      } else {
        // Authenticated user who has NOT opted out: INCLUDE all data including PII
        const customerEmail = this.reservation.email || '';
        const customerPhone = this.reservation.customerPhone || '';

        // Hash email if available (force lowercase before hashing per PDF spec)
        let emailsha256 = '';
        if (customerEmail) {
          emailsha256 = await this.hashEmail(customerEmail);
        }

        // Hash phone if available (remove non-digits before hashing)
        let telephonesha256 = '';
        if (customerPhone) {
          telephonesha256 = await this.hashPhone(customerPhone);
        }

        // Get brand name for category fields
        const brandName = getBrandName() || '';

        // Get user ID and additional profile fields if authenticated (Wyndham Rewards member ID)
        let userId = '';
        let userLanguage = '';
        if (loggedUser) {
          userId = loggedUser.wrNo || loggedUser.memberNumber || '';

          // Extract language preference from preferences array
          if (loggedUser.preferences && Array.isArray(loggedUser.preferences)) {
            const langPref = loggedUser.preferences.find(p => p.preferenceRuleDetailCode === 'CP_LANG_PREF');
            if (langPref && langPref.value) {
              // Convert to 2-letter ISO code (e.g., "en-us" → "en")
              userLanguage = langPref.value.split('-')[0].toLowerCase();
            }
          }
        }

        // Add PII fields (hashed)
        params.emailsha256 = emailsha256;
        params.firstname = this.reservation.firstName || '';
        params.lastname = this.reservation.lastName || '';
        params.telephonesha256 = telephonesha256;

        // Additional optional fields for better targeting
        const paymentType = sessionStorage.getItem('fluentPaymentType') || 'CREDIT_CARD';
        params.paymenttype = paymentType;  // Captured from booking page
        params.primarycategory = 'Travel';  // Transaction category
        params.subcategory = brandName;  // Hotel brand name

        // User ID for loyalty program tracking (if authenticated)
        if (userId) {
          params.userid = userId;
        }

        // Language preference (2-letter ISO code)
        if (userLanguage) {
          params.language = userLanguage;
        }
      }

      // Initialize Fluent per SDK API: new FlowContainer({ params: {...} })
      const fc = new window.FlowContainer({
        params: params
      });

      // Show the modal per SDK API
      const placementId = getFluentPlacementId();
      fc.showById(placementId);

    } catch (error) {
      console.error('[Fluent] SDK initialization or display failed:', error);
      // (handles any SDK errors including 1003 - Resource not found)
      window.dispatchEvent(new CustomEvent('flowContainerClosed'));
    }
  }

  /**
   * Format transaction value to 2 decimal places
   * @param {string|number} price - The price to format
   * @returns {string} - Formatted price with 2 decimal places or empty string
   */
  formatTransactionValue(price) {
    if (!price) {
      return '';
    }

    // Strip currency symbols and text, keep only numbers and decimal point
    const cleanPrice = String(price).replace(/[^0-9.]/g, '');
    const numPrice = parseFloat(cleanPrice);

    if (isNaN(numPrice)) {
      return '';
    }
    return numPrice.toFixed(2);
  }

  /**
   * Check if user opted out of data sharing (should see ads but without PII)
   * @param {Object|null} loggedUser - User profile object (null if not logged in)
   * @returns {boolean} - True if should exclude PII but still show ads
   */
  checkMarketingOptOut(loggedUser) {
    try {
      // 1. Check if opt-out flag in reservation data
      if (this.reservation.marketingOptOut === true) {
        return true;
      }

      // 2. Check user profile for "Third Party Data Sharing" opt-out (CP_3RD_PARTY_MARKETING)
      if (loggedUser && loggedUser.preferences && loggedUser.preferences.length > 0) {
        const prefs = loggedUser.preferences;

        // CP_3RD_PARTY_MARKETING = "Third party details information"
        // If user opted out of data sharing → SHOW ads but exclude PII
        const thirdPartyOptOut = prefs.find(p => p.preferenceRuleDetailCode === 'CP_3RD_PARTY_MARKETING');

        // Value is a string 'true' or 'false', not a boolean
        if (thirdPartyOptOut && thirdPartyOptOut.value === 'false') {
          return true;
        }
      }

      return false;
    } catch (error) {
      console.error('Failed to check marketing opt-out status:', error);
      return false;
    }
  }

  /**
   * Generic SHA-256 hash function with custom normalization
   * @param {string} value - Value to hash
   * @param {string} type - Type of value (HashType.EMAIL or HashType.PHONE) for normalization and fallback behavior
   * @returns {Promise<string>} - SHA-256 hash or fallback value
   */
  async hashValue(value, type = HashType.EMAIL) {
    if (!value) {
      return '';
    }

    try {
      // Normalize based on type
      let normalized;
      if (type === HashType.EMAIL) {
        // Email: lowercase and trim
        normalized = value.toLowerCase().trim();
      } else if (type === HashType.PHONE) {
        // Phone: strip all non-digit characters
        normalized = value.replace(/\D/g, '');
        if (!normalized) {
          return '';
        }
      } else {
        normalized = value;
      }

      // Hash using Web Crypto API
      if (window.crypto && window.crypto.subtle) {
        const encoder = new TextEncoder();
        const data = encoder.encode(normalized);
        const hashBuffer = await window.crypto.subtle.digest('SHA-256', data);
        const hashArray = Array.from(new Uint8Array(hashBuffer));
        const hashHex = hashArray.map(b => b.toString(16).padStart(2, '0')).join('');
        return hashHex;
      } else {
        // Fallback if Web Crypto API not available
        console.warn(`Web Crypto API not available, using fallback for ${type}`);
        return type === HashType.EMAIL ? normalized : '';
      }
    } catch (error) {
      console.error(`${type} hashing failed:`, error);
      return type === HashType.EMAIL ? value : '';
    }
  }

  /**
   * Hash email using SHA-256 (force lowercase before hashing)
   * @param {string} email - Email address to hash
   * @returns {Promise<string>} - Hashed email or normalized email if hashing fails
   */
  async hashEmail(email) {
    return this.hashValue(email, HashType.EMAIL);
  }

  /**
   * Hash phone number using SHA-256 (strip non-digits before hashing)
   * @param {string} phone - Phone number to hash
   * @returns {Promise<string>} - Hashed phone number or empty string if hashing fails
   */
  async hashPhone(phone) {
    return this.hashValue(phone, HashType.PHONE);
  }

  // ==================== END FLUENT INTEGRATION ====================

}

export default new ConfirmationPage();
